/* Lightweight inline SVG icon set — no external dependency. */
const paths = {
  factory: (
    <>
      <path d="M3 21V10l5 3V10l5 3V7l5 3v11H3z" />
      <path d="M7 21v-4M12 21v-4M17 21v-4" />
    </>
  ),
  chart: (
    <>
      <path d="M3 3v18h18" />
      <path d="M7 14l3-4 3 3 4-6" />
    </>
  ),
  leaf: (
    <>
      <path d="M11 20A7 7 0 0 1 4 13c0-5 4-9 16-9 0 8-4 16-9 16z" />
      <path d="M4 20c4-6 7-8 11-9" />
    </>
  ),
  chip: (
    <>
      <rect x="6" y="6" width="12" height="12" rx="2" />
      <path d="M9 9h6v6H9z" />
      <path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3" />
    </>
  ),
  wheat: (
    <>
      <path d="M12 22V8" />
      <path d="M12 8c0-3 2-5 2-5s2 2 2 5-2 3-2 3" />
      <path d="M12 8c0-3-2-5-2-5s-2 2-2 5 2 3 2 3" />
      <path d="M12 13c0-2 2-4 2-4s2 2 2 4-2 2-2 2" />
      <path d="M12 13c0-2-2-4-2-4s-2 2-2 4 2 2 2 2" />
      <path d="M12 18c0-2 2-4 2-4s2 2 2 4-2 2-2 2" />
      <path d="M12 18c0-2-2-4-2-4s-2 2-2 4 2 2 2 2" />
    </>
  ),
  graduation: (
    <>
      <path d="M22 10L12 5 2 10l10 5 10-5z" />
      <path d="M6 12v5c0 1 3 3 6 3s6-2 6-3v-5" />
    </>
  ),
  rupee: (
    <>
      <path d="M6 4h12M6 9h12M6 14l9 7M6 14c0-3 2-5 5-5 3 0 5 2 5 5" />
    </>
  ),
  gavel: (
    <>
      <path d="M14 4l6 6-3 3-6-6 3-3z" />
      <path d="M11 7L4 14l3 3 7-7" />
      <path d="M3 21h8" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" />
    </>
  ),
  gear: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20c0-3 3-5 6-5s6 2 6 5" />
      <path d="M16 5a3 3 0 0 1 0 6M21 20c0-2-2-4-5-4" />
    </>
  ),
  layers: (
    <>
      <path d="M12 2l9 5-9 5-9-5 9-5z" />
      <path d="M3 12l9 5 9-5M3 17l9 5 9-5" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M3 9h18M8 2v4M16 2v4" />
    </>
  ),
  ship: (
    <>
      <path d="M3 18c2 1 4 1 6 0s4-1 6 0 4 1 6 0" />
      <path d="M5 18l-2-7h18l-2 7" />
      <path d="M12 4v7M8 8h8" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M15 9l-2 5-5 2 2-5 5-2z" />
    </>
  ),
  car: (
    <>
      <path d="M5 16v2M19 16v2" />
      <path d="M3 16h18v-4l-2-5H5l-2 5v4z" />
      <circle cx="7" cy="16" r="1.5" />
      <circle cx="17" cy="16" r="1.5" />
    </>
  ),
  pulse: (
    <>
      <path d="M3 12h4l2-6 4 12 2-6h6" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v12M7 10l5 5 5-5" />
      <path d="M5 21h14" />
    </>
  ),
  arrow: (
    <>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </>
  ),
  back: (
    <>
      <path d="M19 12H5M11 18l-6-6 6-6" />
    </>
  ),
  file: (
    <>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z" />
      <path d="M14 3v5h5" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  doc: (
    <>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z" />
      <path d="M14 3v5h5M9 13h6M9 17h6" />
    </>
  ),
  spark: (
    <>
      <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3l8 3v6c0 5-4 8-8 9-4-1-8-4-8-9V6l8-3z" />
      <path d="M9 12l2 2 4-4" />
    </>
  ),
};

export default function Icon({ name, className = "h-6 w-6" }) {
  const node = paths[name] || paths.file;
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {node}
    </svg>
  );
}
